import React from 'react'
import Menu from '../Board-Menu/menu'

const menu = {
  fontSize: '16px',
  textAlign: 'left',
  color: 'white',
}

export default ({ close }) => (
  <div className="menu burgerMenu">
    <div className="community">
      <Menu />
    </div>
    <ul style={menu}>
      <li onClick={close}>
        <a href="/">Home</a>
      </li>
      <li onClick={close}>
        <a href="/en-CA/stats/2WzwJAqfKd3QekqmJcKmli/">About</a>
      </li>
      <li onClick={close}>
        <a href="/en-CA/stats/2WzwJAqfKd3QekqmJcKmli/">Employment Trends</a>
      </li>
      <li onClick={close}>
        <a href="/en-CA/stats/ZtDiHSNyWRJYz57YMk7aX/">Interest Rates Changes</a>
      </li>
      <li onClick={close}>
        <a href="/en-CA/stats/2k7dZil1MPa7B2vbqlNKlH/">Consumer Confidence</a>
      </li>
      <hr />
      <li onClick={close}>
        <a
          target="_blank"
          href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/quarterly-forecasts/"
        >
          Quarterly Forecasts
        </a>
      </li>
      <li onClick={close}>
        <a
          target="_blank"
          href="https://www.crea.ca/housing-market-stats/national-price-map/"
        >
          National Average Price Map
        </a>
      </li>
      <hr />

      <li onClick={close}>
        <a
          href="https://www.crea.ca/advocacy/political-advocacy/"
          target="_blank"
        >
          Advocacy
        </a>
      </li>
      <li onClick={close}>
        <a
          href="https://www.crea.ca/technology/realtor-ca-for-canadians/"
          target="_blank"
        >
          REALTOR® & Consumer Tech
        </a>
      </li>
      <li onClick={close}>
        <a
          href="https://www.crea.ca/standards-programs/reputation/"
          target="_blank"
        >
          Standards & Programs
        </a>
      </li>
      <li onClick={close}>
        <a
          href="https://www.crea.ca/housing-market-stats/canadian-housing-market-stats/"
          target="_blank"
        >
          Housing Market Analysis
        </a>
      </li>
      <li onClick={close}>
        <a href="https://www.crea.ca/media-hub/news/" target="_blank">
          Media Hub
        </a>
      </li>
      <hr />

      <li onClick={close}>
        <a href="https://www.crea.ca/">CREA.CA</a>
      </li>
      <li onClick={close}>
        <a href="https://www.creacafe.ca/">CREA Blog</a>
      </li>
      <li onClick={close}>
        <a href="https://www.realtorscare.ca" target="_blank">
          REALTOR CARE<sup>®</sup>
        </a>
      </li>
      <li onClick={close}>
        <a href="https://www.realtor.ca" target="_blank">
          REALTOR.CA
        </a>
      </li>
      <hr />
      <li onClick={close}>
        <a href="http://www.realtorlink.ca/" target="_blank">
          Member Login
        </a>
      </li>
      <li onClick={close}>
        <a href="https://www.crea.ca/newsroom/">Newsroom</a>
      </li>
      <li onClick={close}>
        <a href="https://www.crea.ca/about/careers/">Careers</a>
      </li>
      <li onClick={close}>
        <a href="https://www.crea.ca/contact/">Contact</a>
      </li>
      <li onClick={close}>
        <a href="/fr-CA/">FR</a>
      </li>
    </ul>
  </div>
)
